// onboard.ts
import init from "@web3-onboard/core";
import injectedModule from "@web3-onboard/injected-wallets";

const PolygonMainNet = {
  id: "0x89",
  token: "POL",
  label: "Polygon Mainnet",
  rpcUrl: "https://polygon-rpc.com/",
};

const chains = [PolygonMainNet];
const injected = injectedModule();

export const web3Onboard = init({
  wallets: [injected],
  chains,
  appMetadata: {
    name: "Web3-Onboard Demo",
    icon: "<svg>My App Icon</svg>",
    description: "A demo of Web3-Onboard.",
  },
});
